/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisitePurchasesCtrl
 * @description A report of purchases for all companies
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisitePurchasesCtrl', ["comparetime", "$filter", "multisite", "$q", "reporttime", "$scope", "StockReport", "title", "userinfo", function(comparetime, $filter, multisite, $q, reporttime, $scope, StockReport, title, userinfo) {
  title.set('Stock Purchases');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphColumns = [
    {label: 'Item Name', type: 'string', key: 'stockItemName'},
    {label: 'Total Cost', type: 'number', key: 'cost', filter: 'currency'}
  ];

  var purchaseResults = {};
  var compareResults = {};
  var allItems = [];
  var compareItems = [];

  var purchaseResultsProcessed = {};
  var compareResultsProcessed = {};

  var updateResults = function() {
    $scope.results = [];

    angular.forEach(allItems, function(item) {
      // skip this item if it came from a disabled company
      if (multisite.isCompanyDisabled(item.companyId)) {
        return;
      }

      // filter out any items from disabled companies
      var filteredItems = $filter('filter')(allItems, function(item) {
        return !multisite.isCompanyDisabled(item.companyId);
      });

      var filteredCompareItems = $filter('filter')(compareItems, function(item) {
        return !multisite.isCompanyDisabled(item.companyId);
      });

      // If it's a shared item, we need to combine all items in the share together
      if (item.stockItemSharedItemId != '00000000-0000-0000-0000-000000000000') {
        // skip if we've already added this share group to the array
        if ($filter('filter')($scope.results, {stockItemSharedItemId: item.stockItemSharedItemId}).length > 0) {
          return;
        }
        var itemGrouped = $filter('filter')(filteredItems, {stockItemSharedItemId: item.stockItemSharedItemId});
        var compareGrouped = $filter('filter')(filteredCompareItems, {stockItemSharedItemId: item.stockItemSharedItemId});

        var baseQuantity = $filter('sumof')(itemGrouped, 'quantity');
        var cost = $filter('sumof')(itemGrouped, 'cost');

        var baseQuantityCompare = $filter('sumof')(compareGrouped, 'quantity');
        var costCompare = $filter('sumof')(compareGrouped, 'cost');

        var unitQuantity = baseQuantity / item.unitRatio;
        var averageUnitCost = unitQuantity == 0 ? 0 : cost / unitQuantity;

        var unitQuantityCompare = baseQuantityCompare / item.unitRatio;
        var averageUnitCostCompare = unitQuantityCompare == 0 ? 0 : costCompare / unitQuantityCompare;

        $scope.results.push({
          stockItemId: item.stockItemId,
          stockItemSharedItemId: item.stockItemSharedItemId,
          stockItemName: item.stockItemName,
          unitQuantity: unitQuantity,
          unitQuantityCompare: unitQuantityCompare,
          cost: cost,
          costCompare: costCompare,
          averageUnitCost: averageUnitCost,
          averageUnitCostCompare: averageUnitCostCompare,
          unitName: item.unitName
        });
      } else {
        var compareItem = $filter('filter')(filteredCompareItems, {id: item.id})[0];

        var itemUnitQuantity = item.quantity / item.unitRatio;
        var itemAverageUnitCost = itemUnitQuantity == 0 ? 0 : item.cost / itemUnitQuantity;

        var itemUnitQuantityCompare = 0;
        var itemAverageUnitCostCompare = 0;
        var compareCost = 0;

        if (compareItem) {
          itemUnitQuantityCompare = compareItem.quantity / item.unitRatio;
          itemAverageUnitCostCompare = itemUnitQuantityCompare == 0 ? 0 : compareItem.cost / itemUnitQuantityCompare;
          compareCost = compareItem.cost;
        }

        $scope.results.push({
          stockItemId: item.stockItemId,
          stockItemSharedItemId: item.stockItemSharedItemId,
          stockItemName: item.stockItemName,
          unitQuantity: itemUnitQuantity,
          unitQuantityCompare: itemUnitQuantityCompare,
          cost: item.cost,
          costCompare: compareCost,
          averageUnitCost: itemAverageUnitCost,
          averageUnitCostCompare: itemAverageUnitCostCompare,
          unitName: item.unitName
        });

      }
    });

    $scope.$emit('update.googleChart');
    $scope.$emit('dataTableUpdate');
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id)) {
        updateResults();
        return;
      }

      if (!purchaseResults[company.id]) {
        purchaseResults[company.id] = StockReport.getItemPurchasesReport(reporttime.start(), reporttime.end(), company.id);
      }
      if ($scope.compare && !compareResults[company.id]) {
        compareResults[company.id] = StockReport.getItemPurchasesReport(comparetime.start(), comparetime.end(), company.id);
      }

      purchaseResults[company.id].then(function(purchaseResult) {
        if (!purchaseResultsProcessed[company.id]) {
          angular.forEach(purchaseResult, function(item) {
            allItems.push({
              companyId: company.id,
              stockItemId: item.stockItemId,
              stockItemSharedItemId: item.stockItemSharedItemId,
              stockItemName: item.stockItemName,
              quantity: item.quantity,
              cost: item.cost,
              unitRatio: item.unitRatio,
              unitName: item.unitName
            });
          });

          purchaseResultsProcessed[company.id] = true;
          updateResults();
        }
      });

      if (compareResults[company.id]) {
        compareResults[company.id].then(function(compareResult) {
          if (!compareResultsProcessed[company.id]) {
            angular.forEach(compareResult, function(item) {
              compareItems.push({
                companyId: company.id,
                stockItemId: item.stockItemId,
                stockItemSharedItemId: item.stockItemSharedItemId,
                stockItemName: item.stockItemName,
                quantity: item.quantity,
                cost: item.cost,
                unitRatio: item.unitRatio,
                unitName: item.unitName
              });
            });

            compareResultsProcessed[company.id] = true;
            updateResults();
          }
        });
      }
    });

    updateResults();
  };

  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      return;
    }

    purchaseResults[company.id] = StockReport.getItemPurchasesReport(reporttime.start(), reporttime.end(), company.id);
    if ($scope.compare) {
      compareResults[company.id] = StockReport.getItemPurchasesReport(comparetime.start(), comparetime.end(), company.id);
    }
  });

  $scope.loading = $q.race(purchaseResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
